<div class="content">
    <button type="button"
            class="button is-primary"
            (click)="onClickEventReceived()"
            [disabled]="disabled"
    >
      <i *ngIf="icon" class="{{ icon }}"></i> &nbsp;

      {{ buttonText }}
    </button>

</div>
